
import { Component, Vue } from "vue-property-decorator";
import topicdetail from "@/template/topic/topicDetail.vue";
@Component
export default class topicDetail extends topicdetail {}
